import React from 'react';

export interface SectionColorScheme {
  border: string;
  background: string;
  titleColor: string;
}

export const SECTION_COLORS: Record<'sender' | 'recipient' | 'packages' | 'other' | 'overview', SectionColorScheme> = {
  sender: { border: '#91caff', background: '#e6f4ff', titleColor: '#0958d9' },
  recipient: { border: '#b7eb8f', background: '#f6ffed', titleColor: '#389e0d' },
  packages: { border: '#ffd591', background: '#fff7e6', titleColor: '#d46b08' },
  other: { border: '#d3adf7', background: '#f9f0ff', titleColor: '#722ed1' },
  overview: { border: '#87e8de', background: '#e6fffb', titleColor: '#08979c' },
};

interface SectionCardProps {
  title: string;
  colorScheme: SectionColorScheme;
  extra?: React.ReactNode;
  /** start：extra 紧挨标题右侧；end：extra 推到标题行最右侧 */
  extraAlign?: 'start' | 'end';
  children: React.ReactNode;
}

/** 4 个板块共用的视觉容器：不用背景色（避免页面显得杂乱），改用带颜色的边框区分板块 */
const SectionCard: React.FC<SectionCardProps> = ({ title, colorScheme, extra, extraAlign = 'start', children }) => (
  <div
    style={{
      border: `2px solid ${colorScheme.border}`,
      borderRadius: 8,
      padding: '12px 16px 16px',
      height: '100%',
      boxSizing: 'border-box',
    }}
  >
    <div
      style={{
        display: 'flex',
        justifyContent: extraAlign === 'end' ? 'space-between' : 'flex-start',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: 12,
        margin: '-12px -16px 12px',
        padding: '0 16px',
        height: 44,
        boxSizing: 'border-box',
        background: colorScheme.border,
        borderRadius: '6px 6px 0 0',
      }}
    >
      <span
        style={{
          margin: 0,
          color: colorScheme.titleColor,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          fontSize: 16,
          fontWeight: 600,
          lineHeight: '44px',
        }}
      >
        {title}
      </span>
      {extra}
    </div>
    {children}
  </div>
);

export default SectionCard;
